import React from 'react';
import { Auth0Provider } from '../lib/keycloak-auth0-shim';

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

const Auth0ProviderWithNavigate: React.FC<Auth0ProviderWithNavigateProps> = ({ children }) => {
  const isConfigured = !!(
    process.env.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_REALM
  );

  if (!isConfigured) {
    return (
      <div style={{ padding: 20, textAlign: 'center' }}>
        <h2>Missing Keycloak Configuration</h2>
        <p>Set REACT_APP_KEYCLOAK_URL, REACT_APP_KEYCLOAK_REALM, and REACT_APP_KEYCLOAK_CLIENT in your .env file</p>
      </div>
    );
  }

  return <Auth0Provider>{children}</Auth0Provider>;
};

export default Auth0ProviderWithNavigate;
